<template>
    <Section v-if="product" class="checkout-flight">
        <template #left>
            <FlightForm :product="product" :sectionId="sectionId" />
        </template>
        <template #right>
            <FlightDetails :product="product" :sectionId="sectionId" :showPrice="false" />
        </template>
    </Section>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import Section from '../../../Shared/Section/Section.vue';
    import FlightForm from './Form/Form.vue';
    import FlightDetails from './Details/Details.vue';

    export default defineComponent({
        name: 'Flight',
        methods: { t },
        components: { Section, FlightForm, FlightDetails },
        props: {
            sectionId: { type: String, required: true },
            productId: { type: String, required: true },
        },
        setup(props) {
            const store = useStore();

            const product = computed<FlightProduct | undefined>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            return { product };
        },
    });
</script>

<style lang="scss">
    @forward 'Flight.scss';
</style>
